import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const pcImg = 'http://geel.fp.08wx.cn/images/4a2e50a776eb7503e9d1908b6e84faa2.jpg';
const h5Img = 'http://geel.fp.08wx.cn/images/7fe9c21acdaa821f6b4ae79004005309.jpg';

const COPY = {
  'zh-CN': {
    title: 'PC 端 & H5 移动端',
    highlight: '全终端覆盖',
    desc: 'PC 端专为专业交易者提供深度功能，H5 移动端为普通用户打造流畅操作体验，同一后台统一管理',
    tabPc: 'PC 专业交易端',
    tabH5: 'H5 移动端',
    cardPc: 'PC 专业交易端',
    cardH5: 'H5 移动端',
    pcModules: [
      { icon: 'ri-line-chart-line', title: '专业交易引擎', features: ['K 线图表（1分钟～月线）', '深度图 & 成交记录', '多窗口布局自定义', 'TradingView 图表集成'] },
      { icon: 'ri-safe-2-line', title: '资产管理中心', features: ['多币种钱包总览', '充提记录与状态追踪', '资产折算与收益统计', 'API 密钥管理'] },
      { icon: 'ri-pulse-line', title: '实时行情系统', features: ['WebSocket 推送行情', '全球主流交易对数据', '指数行情与资金费率', '市场热力图'] },
      { icon: 'ri-stock-line', title: '衍生品交易', features: ['永续合约 & 交割合约', '逐仓 / 全仓保证金', '杠杆倍数 1x-125x', '止盈止损一键设置'] },
    ],
    h5Modules: [
      { icon: 'ri-smartphone-line', title: '轻量化交易', features: ['简洁挂单 & 快捷成交', '一键买卖入门模式', '手势操作图表缩放', '离线行情缓存'] },
      { icon: 'ri-bar-chart-2-line', title: '移动行情', features: ['实时推送价格提醒', '自选列表快速切换', '涨跌幅排行榜', '市场热点资讯'] },
      { icon: 'ri-shield-keyhole-line', title: '安全中心', features: ['生物识别登录（Face ID / Touch ID）', '设备绑定与异地登录警告', '二步验证 & 防钓鱼码', '资金密码独立设置'] },
      { icon: 'ri-user-received-line', title: '新手引导', features: ['分步教程引导新用户', 'KYC 流程移动端优化', '模拟交易练习模式', '多语言客服入口'] },
    ],
  },
  en: {
    title: 'PC Terminal & H5 Mobile',
    highlight: 'Full Multi-Terminal Coverage',
    desc: 'PC terminal delivers pro-level depth for active traders, while H5 offers smooth mobile UX for mass users under one unified backend.',
    tabPc: 'PC Pro Terminal',
    tabH5: 'H5 Mobile',
    cardPc: 'PC Pro Terminal',
    cardH5: 'H5 Mobile',
    pcModules: [
      { icon: 'ri-line-chart-line', title: 'Professional Trading Engine', features: ['Candlestick charts (1m to 1M)', 'Depth chart & trade tape', 'Custom multi-window layout', 'TradingView integration'] },
      { icon: 'ri-safe-2-line', title: 'Asset Management Center', features: ['Multi-asset wallet overview', 'Deposit/withdraw status tracking', 'Asset conversion & PnL stats', 'API key management'] },
      { icon: 'ri-pulse-line', title: 'Real-Time Market Data', features: ['WebSocket streaming', 'Global major pair feeds', 'Index/funding rate panels', 'Market heatmap'] },
      { icon: 'ri-stock-line', title: 'Derivatives Trading', features: ['Perpetual & delivery contracts', 'Isolated/cross margin', 'Leverage 1x-125x', 'One-click TP/SL'] },
    ],
    h5Modules: [
      { icon: 'ri-smartphone-line', title: 'Lightweight Trading', features: ['Simplified order placement', 'Beginner one-tap buy/sell', 'Gesture chart zoom', 'Offline quote cache'] },
      { icon: 'ri-bar-chart-2-line', title: 'Mobile Market Hub', features: ['Realtime price alerts', 'Fast watchlist switching', 'Top movers ranking', 'Market news feed'] },
      { icon: 'ri-shield-keyhole-line', title: 'Security Center', features: ['Biometric login', 'Device binding & abnormal login alerts', '2FA & anti-phishing code', 'Independent funds password'] },
      { icon: 'ri-user-received-line', title: 'New User Guidance', features: ['Step-by-step onboarding', 'Mobile-optimized KYC flow', 'Paper trading mode', 'Multilingual support entry'] },
    ],
  },
  'zh-TW': {
    title: 'PC 端 & H5 移動端',
    highlight: '全終端覆蓋',
    desc: 'PC 端專為專業交易者提供深度功能，H5 移動端為普通用戶打造流暢操作體驗，同一後台統一管理',
    tabPc: 'PC 專業交易端',
    tabH5: 'H5 移動端',
    cardPc: 'PC 專業交易端',
    cardH5: 'H5 移動端',
    pcModules: [
      { icon: 'ri-line-chart-line', title: '專業交易引擎', features: ['K 線圖表（1分鐘～月線）', '深度圖 & 成交記錄', '多窗口布局自定義', 'TradingView 圖表集成'] },
      { icon: 'ri-safe-2-line', title: '資產管理中心', features: ['多幣種錢包總覽', '充提記錄與狀態追蹤', '資產折算與收益統計', 'API 密鑰管理'] },
      { icon: 'ri-pulse-line', title: '實時行情系統', features: ['WebSocket 推送行情', '全球主流交易對數據', '指數行情與資金費率', '市場熱力圖'] },
      { icon: 'ri-stock-line', title: '衍生品交易', features: ['永續合約 & 交割合約', '逐倉 / 全倉保證金', '槓桿倍數 1x-125x', '止盈止損一鍵設置'] },
    ],
    h5Modules: [
      { icon: 'ri-smartphone-line', title: '輕量化交易', features: ['簡潔掛單 & 快捷成交', '一鍵買賣入門模式', '手勢操作圖表縮放', '離線行情緩存'] },
      { icon: 'ri-bar-chart-2-line', title: '移動行情', features: ['實時推送價格提醒', '自選列表快速切換', '漲跌幅排行榜', '市場熱點資訊'] },
      { icon: 'ri-shield-keyhole-line', title: '安全中心', features: ['生物識別登入（Face ID / Touch ID）', '設備綁定與異地登入警告', '二步驗證 & 防釣魚碼', '資金密碼獨立設置'] },
      { icon: 'ri-user-received-line', title: '新手引導', features: ['分步教程引導新用戶', 'KYC 流程移動端優化', '模擬交易練習模式', '多語言客服入口'] },
    ],
  },
} as const;

function getLocale(lng: string) {
  if (lng.startsWith('en')) return 'en';
  if (lng.startsWith('zh-TW')) return 'zh-TW';
  return 'zh-CN';
}

interface CexTerminalSectionProps {
  /** 与 CexHero 锚点联动：从顶部 tab 切到 PC/H5 时同步本区展示并保证 #h5 可滚动定位 */
  heroActiveTab?: string;
}

export default function CexTerminalSection({ heroActiveTab }: CexTerminalSectionProps) {
  const [terminal, setTerminal] = useState<'pc' | 'h5'>('pc');
  const { i18n } = useTranslation();
  const copy = COPY[getLocale(i18n.resolvedLanguage || i18n.language || 'zh-CN')];

  useEffect(() => {
    if (heroActiveTab === 'pc' || heroActiveTab === 'h5') {
      setTerminal(heroActiveTab);
    }
  }, [heroActiveTab]);

  return (
    <section id="pc" className="bg-light-section py-24 border-t border-primary/10">
      {/* 始终存在于 DOM，供 CexPage scrollToSection('h5') 定位；内容区仅在 terminal==='h5' 时挂载 */}
      <div id="h5" className="sr-only" aria-hidden />
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col items-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <i className="ri-device-line text-primary text-xs" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">Terminal Forms</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-6 text-center">
            {copy.title}
            <br />
            <span className="text-primary">{copy.highlight}</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-xl text-center mb-8">{copy.desc}</p>
          <div className="flex items-center p-1 bg-white border border-primary/15 rounded-full">
            {(['pc', 'h5'] as const).map((t) => (
              <button
                key={t}
                onClick={() => setTerminal(t)}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${terminal === t ? 'bg-primary text-white' : 'text-gray-400 hover:text-gray-600'}`}
              >
                <i className={t === 'pc' ? 'ri-computer-line' : 'ri-smartphone-line'} />
                {t === 'pc' ? copy.tabPc : copy.tabH5}
              </button>
            ))}
          </div>
        </div>

        {terminal === 'pc' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-16 items-start">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15">
              <div className="w-full h-[360px]">
                <img src={pcImg} alt="PC Trading Platform" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/50 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-2.5 backdrop-blur-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-computer-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardPc}</span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {copy.pcModules.map((m, i) => (
                <div key={i} className="bg-white border border-primary/10 rounded-xl p-5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 mb-3">
                    <i className={`${m.icon} text-sm text-primary`} />
                  </div>
                  <h4 className="text-gray-800 text-sm font-semibold mb-2">{m.title}</h4>
                  <ul className="space-y-1.5">
                    {m.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-2 text-xs text-gray-500">
                        <i className="ri-check-line text-primary text-xs mt-0.5 flex-shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        {terminal === 'h5' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-16 items-start">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 flex items-center justify-center bg-light-alt" style={{ minHeight: 360 }}>
              <div className="w-full h-[360px]">
                <img src={h5Img} alt="H5 Mobile Trading" className="w-full h-full object-cover object-center" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/50 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-2.5 backdrop-blur-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-smartphone-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardH5}</span>
                </div>
              </div>
              <div className="absolute bottom-4 right-4 flex flex-col gap-1.5">
                {['iOS', 'Android', 'PWA'].map((platform, i) => (
                  <span key={i} className="px-2.5 py-1 bg-white/95 border border-primary/20 text-primary text-xs rounded-lg text-center backdrop-blur-sm">{platform}</span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {copy.h5Modules.map((m, i) => (
                <div key={i} className="bg-white border border-primary/10 rounded-xl p-5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 mb-3">
                    <i className={`${m.icon} text-sm text-primary`} />
                  </div>
                  <h4 className="text-gray-800 text-sm font-semibold mb-2">{m.title}</h4>
                  <ul className="space-y-1.5">
                    {m.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-2 text-xs text-gray-500">
                        <i className="ri-check-line text-primary text-xs mt-0.5 flex-shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
